import * as React from "react";
import { useState, useCallback, useEffect } from "react";
import { useFormikContext } from "formik";
import debounce from "lodash/debounce";
import { FormikFormGroup } from "components/common";
import { Button, Input } from "components/bootstrap";
const ABSKeySecretFieldGroup = ({ isKeySet, handleAccountKeyChange }) => {
  const { setFieldValue } = useFormikContext();
  const [isCreate] = useState(() => !isKeySet);
  const [showResetPasswordButton, setShowResetPasswordButton] = useState(isKeySet);
  const setAccessKey = useCallback(
    (nextAccessKey) => {
      setFieldValue("settings.key", nextAccessKey);
    },
    [setFieldValue]
  );
  useEffect(() => {
    if (isKeySet) {
      setAccessKey({ keep_value: true });
    }
  }, [isKeySet, setAccessKey]);
  const toggleAccountKeyReset = useCallback(() => {
    if (showResetPasswordButton) {
      setAccessKey({ delete_value: true });
      setShowResetPasswordButton(false);
      return;
    }
    setAccessKey({ keep_value: true });
    setShowResetPasswordButton(true);
  }, [setAccessKey, showResetPasswordButton]);
  const debouncedHanldeAccountKeyChange = debounce(handleAccountKeyChange, 200);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.account_name",
      type: "text",
      label: "Azure account",
      placeholder: "your-account-name",
      help: "The name of your Azure storage account.",
      required: true,
      labelClassName: "",
      wrapperClassName: ""
    }
  ), showResetPasswordButton ? /* @__PURE__ */ React.createElement(Input, { id: "azure_account_reset", label: "Azure Account Key", labelClassName: "", wrapperClassName: "" }, " ", /* @__PURE__ */ React.createElement(Button, { onClick: toggleAccountKeyReset }, "Reset password")) : /* @__PURE__ */ React.createElement(
    Input,
    {
      name: "settings.key",
      id: "key",
      type: "password",
      label: "Azure account key",
      onChange: ({ target: { value } }) => debouncedHanldeAccountKeyChange(value),
      buttonAfter: !isCreate ? /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: toggleAccountKeyReset }, "Undo Reset") : void 0,
      placeholder: "****************",
      help: "The account key for your Azure storage account.",
      required: true
    }
  ));
};
export default ABSKeySecretFieldGroup;
